//wordpress dependencies
const { __ } = wp.i18n;
const { InspectorControls, PanelColorSettings, MediaUpload } = wp.blockEditor;
import {
	TextHighlight, TextControl, BaseControl, Button, ButtonGroup, ColorPalette, Dropdown, PanelBody, RangeControl, SelectControl, TabPanel, ToggleControl, __experimentalUnitControl as UnitControlEMG
} from "@wordpress/components";
const { useEffect, useState } = wp.element;

//internal dependencies
import ColorControl from "../../util/color-control";
import DimensionsControl from "../../util/dimensions-control";
import UnitControl from "../../util/unit-control";
import {
	BORDER_STYLES, COLORS, CURRENCY_POSITION, CONTENT_ALIGNMENT, BTNTYPE, FONT_WEIGHTS,
	NORMAL_HOVER, STYLE_OPTIONS, TEXT_TRANSFORM
} from "./constants";

import SortableFeatures from "./sortable-features";


//external dependencies
import axios from "axios";
import Qs from 'qs';

import FontIconPicker from "@fonticonpicker/react-fonticonpicker";
import RTCLGBIcon from "../../util/RTCLGB-icon-controls/RTCLGBIcon.json";
import renderSVG from "../../util/RTCLGB-icon-controls/renderIcon"

function Inspector(props) {
	const { attributes, setAttributes } = props;

	const {
		style,
		title,
		currency,
		currency_position,
		price,
		unit,
		badge,
		content_alignment,
		btntext,
		btntype,
		buttonurl,
		page_link,
		button_icon,
		button_icon_size,
		button_icon_gap,
		features,
		box_icon,

		title_spacing,
		title_typo,
		title_color,

		badge_typo,
		badge_color,
		badge_bg_color,

		header_icon_color3,
		header_icon_bg_color3,
		header_icon_size3,

		header_spacing2,
		header_bg_color2,
		body_spacing2,

		price_color,
		price_spacing,
		price_typo,
		currency_typo,
		unit_typo,
		unit_color,

		feature_spacing,
		feature_typo,
		feature_color,
		feature_icon_color,
		feature_icon_size,
		feature_icon_gap,

		button_padding,
		button_margin,
		button_width,
		button_typo,
		button_color_style,
		button_bg_color,
		button_text_color,
		button_border_type,
		button_border,
		button_border_color,
		button_border_radius,
		hv_button_bg_color,
		hv_button_text_color,
		hv_button_border_type,
		hv_button_border,
		hv_button_border_color,
		container_margin,
		container_padding,
		containerBGColor,
		container_border_type,
		container_border,
		container_border_color,
		container_border_radius
	} = attributes;

	const [pricingPost, setPricingPost] = useState([]);
	useEffect(() => {
		let data = {
			action: 'rtcl_gb_pricing_table_post',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}
		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let pricingPosts = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					pricingPosts[ai] = { value, label };
					ai++;
				}
				setPricingPost([...pricingPosts])
			})
			.catch((error) => console.log(error));
	}, []);

	const TITLE_SIZE_MAX = title_typo["size"]["unit"] === "em" ? 10 : 100;
	const TITLE_SIZE_STEP = title_typo["size"]["unit"] === "em" ? 0.1 : 1;
	const PRICE_SIZE_MAX = price_typo["size"]["unit"] === "em" ? 10 : 100;
	const PRICE_SIZE_STEP = price_typo["size"]["unit"] === "em" ? 0.1 : 1;
	const CURRENCY_SIZE_MAX = currency_typo["size"]["unit"] === "em" ? 10 : 100;
	const CURRENCY_SIZE_STEP = currency_typo["size"]["unit"] === "em" ? 0.1 : 1;
	const UNIT_SIZE_MAX = unit_typo["size"]["unit"] === "em" ? 10 : 100;
	const UNIT_SIZE_STEP = unit_typo["size"]["unit"] === "em" ? 0.1 : 1;
	const BUTTON_SIZE_MAX = button_typo["size"]["unit"] === "em" ? 10 : 100;
	const BUTTON_SIZE_STEP = button_typo["size"]["unit"] === "em" ? 0.1 : 1;


	let svg_icons = Object.keys(RTCLGBIcon);


	const onFeatureAdd = () => {
		const count = attributes.features.length + 1;
		const features = [
			...attributes.features,
			{
				icon: "fas fa-check",
				text: `Feature ${count}`,
				color: "#03bb89",
			},
		];
		setAttributes({ features });
	};


	return (
		<InspectorControls key="controls">
			<div className="rtcl-gb-panel-control">
				<TabPanel
					className="rtcl-gb-parent-tab-panel"
					activeClass="active-tab"
					tabs={[
						{
							name: "general",
							title: "General",
							className: "rtcl-gb-tab general",
						},
						{
							name: "styles",
							title: "Styles",
							className: "rtcl-gb-tab styles",
						},
						{
							name: "advance",
							title: "Advance",
							className: "rtcl-gb-tab advance",
						},
					]}
				>
					{(tab) => (
						<div className={"rtcl-gb-tab-controls" + tab.name}>

							{tab.name === "general" && (
								<>
									<PanelBody title={__("General", "classified-listing")} initialOpen={true}>
										<SelectControl
											label={__('Style', 'classified-listing')}
											options={STYLE_OPTIONS}
											value={style}
											onChange={(style) => {
												setAttributes({ style })
											}}
										/>
										<TextControl
											label={__('Title', 'classified-listing')}
											value={title}
											onChange={(title) => {
												setAttributes({ title })
											}}
										/>
										<TextControl
											label={__('Currency Symbol', 'classified-listing')}
											help={__('Currency sign eg. $', 'classified-listing')}
											value={currency}
											onChange={(currency) => {
												setAttributes({ currency })
											}}
										/>
										<SelectControl
											label={__('Currency Position', 'classified-listing')}
											options={CURRENCY_POSITION}
											value={currency_position}
											onChange={(currency_position) => {
												setAttributes({ currency_position })
											}}
										/>

										<TextControl
											label={__('Price', 'classified-listing')}
											value={price}
											onChange={(price) => {
												setAttributes({ price })
											}}
										/>

										<TextControl
											label={__('Unit Name', 'classified-listing')}
											help={__("eg. month or year. Keep empty if you don't want to show unit", "classified-listing")}
											value={unit}
											onChange={(unit) => {
												setAttributes({ unit })
											}}
										/>

										<TextControl
											label={__('Badge', 'classified-listing')}
											value={badge}
											onChange={(badge) => {
												setAttributes({ badge })
											}}
										/>

										{style === '3' && (
											<BaseControl label={__("Header Icon")}	>
												<FontIconPicker
													icons={svg_icons}
													renderFunc={renderSVG}
													theme="default"
													value={box_icon}
													onChange={(box_icon) => setAttributes({
														box_icon
													})}
													isMulti={false}
													noSelectedPlaceholder={__("Select Icon", 'classified-listing')}
												/>
											</BaseControl>
										)}

										<SelectControl
											label={__('Content Alignment', 'classified-listing')}
											options={CONTENT_ALIGNMENT}
											value={content_alignment}
											onChange={(content_alignment) => {
												setAttributes({ content_alignment })
											}}
										/>
									</PanelBody>

									<PanelBody title={__("Feature", "classified-listing")} initialOpen={false}>

										<SortableFeatures
											features={attributes.features}
											setAttributes={setAttributes}
										/>

										<Button
											className="rtcl-gb-pricebox-feature-button"
											label={__("Add feature", "classified-listing")}
											icon="plus-alt"
											onClick={onFeatureAdd}
										>
											<span className="rtcl-gb-pricebox-add-button-label">
												{__("Add Feature", "classified-listing")}
											</span>
										</Button>
									</PanelBody>

									<PanelBody title={__("Button", "classified-listing")} initialOpen={false}>

										<TextControl
											label={__('Button Text', 'classified-listing')}
											value={btntext}
											onChange={(btntext) => {
												setAttributes({ btntext })
											}}
										/>

										<SelectControl
											label={__('Button Link Type', 'classified-listing')}
											options={BTNTYPE}
											value={btntype}
											onChange={(btntype) => {
												setAttributes({ btntype })
											}}
										/>

										{btntype === 'custom' && (
											<TextControl
												label={__('Button URL', 'classified-listing')}
												help={__('eg.https://your-link.com', 'classified-listing')}
												value={buttonurl}
												onChange={(buttonurl) => {
													setAttributes({ buttonurl })
												}}
											/>
										)}

										{btntype === 'page' && (
											<SelectControl
												label={__('Select Pricing', 'classified-listing')}
												options={pricingPost}
												value={page_link}
												onChange={(page_link) => {
													setAttributes({ page_link })
												}}
											/>
										)}


										<BaseControl label={__("Button Icon")}	>
											<FontIconPicker
												icons={svg_icons}
												renderFunc={renderSVG}
												theme="default"
												value={button_icon}
												onChange={(button_icon) => setAttributes({
													button_icon
												})}
												isMulti={false}
												noSelectedPlaceholder={__("Select Icon", 'classified-listing')}
											/>
										</BaseControl>


										<RangeControl
											label={__("Icon Size")}
											allowReset={true}
											value={button_icon_size}
											onChange={(button_icon_size) => setAttributes({
												button_icon_size
											})}
											min={0}
											max={100}
										/>
										<RangeControl
											label={__("Icon Gap")}
											allowReset={true}
											value={button_icon_gap}
											onChange={(button_icon_gap) => setAttributes({
												button_icon_gap
											})}
											min={0}
											max={100}
										/>
									</PanelBody>
								</>
							)}

							{tab.name === "styles" && (
								<>

									{'2' === style && (
										<>
											<PanelBody title={__("Header", "classified-listing")} initialOpen={true}>

												<ColorControl
													label={__("Background")}
													color={header_bg_color2}
													onChange={(header_bg_color2) => setAttributes({
														header_bg_color2
													})
													}
												/>

												<BaseControl>
													<UnitControl
														selectedUnit={header_spacing2["unit"]}
														unitTypes={[
															{ label: "px", value: "px" },
															{ label: "%", value: "%" },
														]}
														onClick={(unit) =>
															setAttributes({
																header_spacing2: { ...header_spacing2, unit }
															})
														}
													/>
													<DimensionsControl
														label={__("Header Spacing", "classified-listing")}
														top={header_spacing2["top"]}
														right={header_spacing2["right"]}
														bottom={header_spacing2["bottom"]}
														left={header_spacing2["left"]}
														onChange={({ top, right, bottom, left }) =>
															setAttributes({
																header_spacing2: { ...header_spacing2, top, bottom, left, right }
															})
														}
													/>
												</BaseControl>



											</PanelBody>

											<PanelBody title={__("Body", "classified-listing")} initialOpen={true}>
												<BaseControl>
													<UnitControl
														selectedUnit={body_spacing2["unit"]}
														unitTypes={[
															{ label: "px", value: "px" },
															{ label: "%", value: "%" },
														]}
														onClick={(unit) =>
															setAttributes({
																body_spacing2: { ...body_spacing2, unit }
															})
														}
													/>
													<DimensionsControl
														label={__("Body Spacing", "classified-listing")}
														top={body_spacing2["top"]}
														right={body_spacing2["right"]}
														bottom={body_spacing2["bottom"]}
														left={body_spacing2["left"]}
														onChange={({ top, right, bottom, left }) =>
															setAttributes({
																body_spacing2: { ...body_spacing2, top, bottom, left, right }
															})
														}
													/>
												</BaseControl>

											</PanelBody>
										</>
									)}

									{'3' === style && (
										<PanelBody title={__("Header Icon", "classified-listing")} initialOpen={true}>
											<ColorControl
												label={__("Background")}
												color={header_icon_bg_color3}
												onChange={(header_icon_bg_color3) => setAttributes({
													header_icon_bg_color3
												})
												}
											/>
											<ColorControl
												label={__("Color")}
												color={header_icon_color3}
												onChange={(header_icon_color3) => setAttributes({
													header_icon_color3
												})
												}
											/>
											<RangeControl
												label={__("Icon Size")}
												allowReset={true}
												value={header_icon_size3}
												onChange={(header_icon_size3) => setAttributes({
													header_icon_size3
												})}
												min={0}
												max={100}
											/>
										</PanelBody>
									)}

									<PanelBody title={__("Title", "classified-listing")} initialOpen={true}>
										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={title_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																title_typo: { ...title_typo, size: { ...title_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(title_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																title_typo: { ...title_typo, size: { ...title_typo["size"], lg } }
															})}
															min={0}
															step={TITLE_SIZE_STEP}
															max={TITLE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={title_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ title_typo: { ...title_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={title_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ title_typo: { ...title_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(title_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ title_typo: { ...title_typo, spacing: { ...title_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(title_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ title_typo: { ...title_typo, height: { ...title_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={title_spacing["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														title_spacing: { ...title_spacing, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Title Spacing", "classified-listing")}
												top={title_spacing["top"]}
												right={title_spacing["right"]}
												bottom={title_spacing["bottom"]}
												left={title_spacing["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														title_spacing: { ...title_spacing, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<ColorControl
											label={__("Color")}
											color={title_color}
											onChange={(title_color) => setAttributes({
												title_color
											})
											}
										/>
									</PanelBody>

									{badge && (
										<PanelBody title={__("Badge", "classified-listing")} initialOpen={false}>
											<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
												<Dropdown
													className="rtcl-gb-typography-dropdown"
													contentClassName="my-popover-content-classname"
													position="bottom right"
													renderToggle={({ isOpen, onToggle }) => (
														<Button
															isSmall
															onClick={onToggle}
															aria-expanded={isOpen}
															icon="edit"
														></Button>
													)}
													renderContent={() => (
														<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
															<UnitControl
																selectedUnit={badge_typo["size"]["unit"]}
																unitTypes={[
																	{ label: "px", value: "px" },
																	{ label: "%", value: "%" },
																	{ label: "em", value: "em" },
																]}
																onClick={(unit) => setAttributes({
																	badge_typo: { ...badge_typo, size: { ...badge_typo["size"], unit } }
																})}
															/>

															<RangeControl
																label={__("Font Size")}
																value={parseInt(badge_typo["size"]["lg"])}
																onChange={(lg) => setAttributes({
																	badge_typo: { ...badge_typo, size: { ...badge_typo["size"], lg } }
																})}
																min={0}
																step={TITLE_SIZE_STEP}
																max={TITLE_SIZE_MAX}
															/>

															<SelectControl
																label={__("Font Weight")}
																value={badge_typo["weight"]}
																options={FONT_WEIGHTS}
																onChange={(weight) =>
																	setAttributes({ badge_typo: { ...badge_typo, weight } })
																}
															/>

															<SelectControl
																label={__("Text Transform")}
																value={badge_typo["transform"]}
																options={TEXT_TRANSFORM}
																onChange={(transform) =>
																	setAttributes({ badge_typo: { ...badge_typo, transform } })
																}
															/>

															<RangeControl
																label={__("Letter Spacing")}
																value={parseInt(badge_typo["spacing"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ badge_typo: { ...badge_typo, spacing: { ...badge_typo["spacing"], lg } } })
																}
																min={0}
																max={10}
															/>

															<RangeControl
																label={__("Line Height")}
																value={parseInt(badge_typo["height"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ badge_typo: { ...badge_typo, height: { ...badge_typo["height"], lg } } })
																}
																min={-1}
																max={100}
															/>

														</div>
													)}
												/>
											</BaseControl>
											<ColorControl
												label={__("Background Color")}
												color={badge_bg_color}
												onChange={(badge_bg_color) => setAttributes({
													badge_bg_color
												})
												}
											/>
											<ColorControl
												label={__("Text Color")}
												color={badge_color}
												onChange={(badge_color) => setAttributes({
													badge_color
												})
												}
											/>
										</PanelBody>
									)}



									<PanelBody title={__("Price", "classified-listing")} initialOpen={false}>

										<ColorControl
											label={__("Color")}
											color={price_color}
											onChange={(price_color) => setAttributes({
												price_color
											})
											}
										/>

										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={price_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																price_typo: { ...price_typo, size: { ...price_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(price_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																price_typo: { ...price_typo, size: { ...price_typo["size"], lg } }
															})}
															min={0}
															step={PRICE_SIZE_STEP}
															max={PRICE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={price_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ price_typo: { ...price_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={price_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ price_typo: { ...price_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(price_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ price_typo: { ...price_typo, spacing: { ...price_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(price_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ price_typo: { ...price_typo, height: { ...price_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl label={__("Currency Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={currency_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																currency_typo: { ...currency_typo, size: { ...currency_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(currency_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																currency_typo: { ...currency_typo, size: { ...currency_typo["size"], lg } }
															})}
															min={0}
															step={CURRENCY_SIZE_STEP}
															max={CURRENCY_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={currency_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ currency_typo: { ...currency_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={currency_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ currency_typo: { ...currency_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(currency_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ currency_typo: { ...currency_typo, spacing: { ...currency_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(currency_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ currency_typo: { ...currency_typo, height: { ...currency_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={price_spacing["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														price_spacing: { ...price_spacing, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Spacing", "classified-listing")}
												top={price_spacing["top"]}
												right={price_spacing["right"]}
												bottom={price_spacing["bottom"]}
												left={price_spacing["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														price_spacing: { ...price_spacing, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<BaseControl label={__("Unit Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={unit_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																unit_typo: { ...unit_typo, size: { ...unit_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(unit_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																unit_typo: { ...unit_typo, size: { ...unit_typo["size"], lg } }
															})}
															min={0}
															step={UNIT_SIZE_STEP}
															max={UNIT_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={unit_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ unit_typo: { ...unit_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={unit_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ unit_typo: { ...unit_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(unit_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ unit_typo: { ...unit_typo, spacing: { ...unit_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(unit_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ unit_typo: { ...unit_typo, height: { ...unit_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<ColorControl
											label={__("Unit Color")}
											color={unit_color}
											onChange={(unit_color) => setAttributes({
												unit_color
											})
											}
										/>

									</PanelBody>

									<PanelBody title={__("Feature", "classified-listing")} initialOpen={false}>
										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={feature_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																feature_typo: { ...feature_typo, size: { ...feature_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(feature_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																feature_typo: { ...feature_typo, size: { ...feature_typo["size"], lg } }
															})}
															min={0}
															step={TITLE_SIZE_STEP}
															max={TITLE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={feature_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ feature_typo: { ...feature_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={feature_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ feature_typo: { ...feature_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(feature_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ feature_typo: { ...feature_typo, spacing: { ...feature_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(feature_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ feature_typo: { ...feature_typo, height: { ...feature_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>
										<ColorControl
											label={__("Color")}
											color={feature_color}
											onChange={(feature_color) => setAttributes({
												feature_color
											})
											}
										/>
										<BaseControl>
											<UnitControl
												selectedUnit={feature_spacing["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														feature_spacing: { ...feature_spacing, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Feature Spacing", "classified-listing")}
												top={feature_spacing["top"]}
												right={feature_spacing["right"]}
												bottom={feature_spacing["bottom"]}
												left={feature_spacing["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														feature_spacing: { ...feature_spacing, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<ColorControl
											label={__("Icon Color")}
											color={feature_icon_color}
											onChange={(feature_icon_color) => setAttributes({
												feature_icon_color
											})
											}
										/>

										<RangeControl
											label={__("Icon Size")}
											allowReset={true}
											value={feature_icon_size}
											onChange={(feature_icon_size) => setAttributes({
												feature_icon_size
											})}
											min={0}
											max={100}
										/>
										<RangeControl
											label={__("Icon Gap")}
											allowReset={true}
											value={feature_icon_gap}
											onChange={(feature_icon_gap) => setAttributes({
												feature_icon_gap
											})}
											min={0}
											max={100}
										/>

									</PanelBody>

									<PanelBody title={__("Button", "classified-listing")} initialOpen={false}>

										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={button_typo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																button_typo: { ...button_typo, size: { ...button_typo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(button_typo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																button_typo: { ...button_typo, size: { ...button_typo["size"], lg } }
															})}
															min={0}
															step={BUTTON_SIZE_STEP}
															max={BUTTON_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={button_typo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ button_typo: { ...button_typo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={button_typo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ button_typo: { ...button_typo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(button_typo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ button_typo: { ...button_typo, spacing: { ...button_typo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(button_typo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ button_typo: { ...button_typo, height: { ...button_typo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={button_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														button_margin: { ...button_margin, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Margin", "classified-listing")}
												top={button_margin["top"]}
												right={button_margin["right"]}
												bottom={button_margin["bottom"]}
												left={button_margin["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														button_margin: { ...button_margin, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={button_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														button_padding: { ...button_padding, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Padding", "classified-listing")}
												top={button_padding["top"]}
												right={button_padding["right"]}
												bottom={button_padding["bottom"]}
												left={button_padding["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														button_padding: { ...button_padding, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<RangeControl
											label={__("Min Width")}
											allowReset={true}
											value={button_width}
											onChange={(button_width) => setAttributes({ button_width })}
											min={0}
											max={300}
										/>

										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={button_color_style === item.value}
														isSecondary={button_color_style !== item.value}
														onClick={() => setAttributes({ button_color_style: item.value })}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{button_color_style === "normal" && (
											<>
												<ColorControl
													label={__("Button Background")}
													color={button_bg_color}
													onChange={(button_bg_color) => setAttributes({
														button_bg_color
													})
													}
												/>
												<ColorControl
													label={__("Button Text Color")}
													color={button_text_color}
													onChange={(button_text_color) => setAttributes({
														button_text_color
													})
													}
												/>
												<SelectControl
													label={__('Border Style', 'classified-listing')}
													options={BORDER_STYLES}
													value={button_border_type}
													onChange={(button_border_type) => {
														setAttributes({ button_border_type })
													}}
												/>

												{(button_border_type !== 'none' && button_border_type) && (<>
													<BaseControl label={__("Width", "classified-listing")}>
														<UnitControlEMG
															value={button_border}
															onChange={(button_border) => setAttributes({
																button_border
															})
															}
														/>
													</BaseControl>

													<ColorControl
														label={__("Border Color")}
														color={button_border_color}
														onChange={(button_border_color) => setAttributes({
															button_border_color
														})
														}
													/>
												</>)}

											</>
										)}

										{button_color_style === "hover" && (
											<>
												<ColorControl
													label={__("Button Background")}
													color={hv_button_bg_color}
													onChange={(hv_button_bg_color) => setAttributes({
														hv_button_bg_color
													})
													}
												/>
												<ColorControl
													label={__("Button Text Color")}
													color={hv_button_text_color}
													onChange={(hv_button_text_color) => setAttributes({
														hv_button_text_color
													})
													}
												/>

												<SelectControl
													label={__('Border Style', 'classified-listing')}
													options={BORDER_STYLES}
													value={hv_button_border_type}
													onChange={(hv_button_border_type) => {
														setAttributes({ hv_button_border_type })
													}}
												/>
												{(hv_button_border_type !== 'none' && hv_button_border_type) && (<>
													<BaseControl label={__("Width", "classified-listing")}>
														<UnitControlEMG
															value={hv_button_border}
															onChange={(hv_button_border) => setAttributes({
																hv_button_border
															})
															}
														/>
													</BaseControl>

													<ColorControl
														label={__("Border Color")}
														color={hv_button_border_color}
														onChange={(hv_button_border_color) => setAttributes({
															hv_button_border_color
														})
														}
													/>
												</>)}

											</>
										)}

										<BaseControl>
											<UnitControl
												selectedUnit={button_border_radius["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														button_border_radius: { ...button_border_radius, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Border Radius", "classified-listing")}
												top={button_border_radius["top"]}
												right={button_border_radius["right"]}
												bottom={button_border_radius["bottom"]}
												left={button_border_radius["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														button_border_radius: { ...button_border_radius, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

									</PanelBody>
								</>
							)}

							{tab.name === "advance" && (
								<>
									<PanelBody title={__("Main Wrapper", "classified-listing")} initialOpen={true}>

										<BaseControl>
											<UnitControl
												selectedUnit={container_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													container_padding: { ...container_padding, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Main Wrapper Padding", "classified-listing")}
												top={container_padding["top"]}
												right={container_padding["right"]}
												bottom={container_padding["bottom"]}
												left={container_padding["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													container_padding: { ...container_padding, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={container_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													container_margin: { ...container_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Main Wrapper Margin", "classified-listing")}
												top={container_margin["top"]}
												right={container_margin["right"]}
												bottom={container_margin["bottom"]}
												left={container_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													container_margin: { ...container_margin, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<SelectControl
											label={__('Border Style', 'classified-listing')}
											options={BORDER_STYLES}
											value={container_border_type}
											onChange={(container_border_type) => {
												setAttributes({ container_border_type })
											}}
										/>
										{(container_border_type !== 'none' && container_border_type) && (<>
											<BaseControl label={__("Width", "classified-listing")}>
												<UnitControlEMG
													value={container_border}
													onChange={(container_border) => setAttributes({
														container_border
													})
													}
												/>
											</BaseControl>

											<ColorControl
												label={__("Border Color")}
												color={container_border_color}
												onChange={(container_border_color) => setAttributes({
													container_border_color
												})
												}
											/>
										</>
										)}
										<BaseControl>
											<UnitControl
												selectedUnit={container_border_radius["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														container_border_radius: { ...container_border_radius, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Border Radius", "classified-listing")}
												top={container_border_radius["top"]}
												right={container_border_radius["right"]}
												bottom={container_border_radius["bottom"]}
												left={container_border_radius["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														container_border_radius: { ...container_border_radius, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<BaseControl label={__("Background Color", "classified-listing")}>
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={containerBGColor}
												onChange={(containerBGColor) => setAttributes({
													containerBGColor
												})}
											/>
										</BaseControl>

									</PanelBody>
								</>
							)}

						</div>
					)}
				</TabPanel>
			</div>
		</InspectorControls >
	)

}

export default Inspector;